<template>
	<div class="sample-data-for-subflow-draft">
		<div class="sample-title flex-centerize mt-2 mb-2 font-size-lg">This subflow is in trigger testing mode</div>
		<div class="sample-content display-flex flex-column">
			<div class="flex-1">
				<SubFlowParamsForm
					class="mt-6 mx-2"
					:fieldsDefinitions="fieldsDefinitions"
					:node="node"
					@updateSubflowParams="(...args) => $emit('updateSubflowParams', ...args)"
				/>
			</div>
			<SampleDataCTA
				class="py-2 shadow-box-top-border"
				:isSendingSampleData="isSendingSampleData"
				@sendTestDataToSubflow="(...args) => $emit('sendTestDataToSubflow', ...args)"
				@cancelSendTestDataToSubflow="$emit('setIsWaitingForSample', false)"
			/>
		</div>
	</div>
</template>

<script>
import SampleDataCTA from '../../helpers/SampleDataCTA';
import SubFlowParamsForm from './SubFlowParamsForm';

export default {
	name: 'SubflowSampleDataModal',
	components: {
		SubFlowParamsForm,
		SampleDataCTA,
	},
	props: {
		node: { type: Object },
		fieldsDefinitions: { type: Array },
		isSendingSampleData: { type: Boolean },
	},
};
</script>

<style scoped lang="scss">
.sample-data-for-subflow-draft {
	$m-top: 148px;

	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: calc(100% - #{$m-top});
	margin-top: $m-top;
	padding: 6px;
	background: var(--sixth-color);
	border-top-left-radius: 17px;
	border-top-right-radius: 17px;

	.sample-title {
		color: var(--input-bg-color);
	}
	.sample-content {
		background: var(--primary-bg-color);
		height: 95%;
		width: 100%;
	}
}
</style>
